import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Padrão de Estoque',
  path: '/merenda/estoquepadrao',
  name: 'estoquepadrao',
  component: () => import('@/views/merenda/estoquepadrao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.PADRAOESTOQUENOVO_MENU_1900200199],
  },
  goesToMenu: true,
 },
]
